import { Flex, Text } from "@chakra-ui/react";
import moment from "moment";
import React, { useCallback, useMemo } from "react";
import { BusTime } from "../../data/buses.api";

type Props = {
  busTime: BusTime;
  showScheduledTime?: boolean;
  arrivalTime?: boolean;
};

const BusArrivalTime = ({ busTime, showScheduledTime, arrivalTime }: Props) => {
  const getDepartureTime = useCallback((isoString: string) => {
    const diff = moment(isoString).diff(moment());
    const minutes = Math.round(diff / 60 / 1000);
    if (minutes >= 60) return moment(isoString).format("HH:mm");
    else if (minutes > 0) return `${minutes} mins`;
    else return "Due";
  }, []);

  const timetableTime = useMemo(() => {
    if (!arrivalTime) return moment(busTime.aimedDepartureTime).format("HH:mm");
  }, [busTime, arrivalTime]);

  const expectedTime = useMemo(() => {
    return moment(
      arrivalTime ? busTime.expectedArrivalTime : busTime.expectedDepartureTime
    ).format("HH:mm");
  }, [busTime, arrivalTime]);

  return (
    <Flex direction="column" align="end" fontWeight="bold">
      {showScheduledTime ? (
        <>
          <Text>{timetableTime}</Text>
          <Text opacity={0.5}>
            {timetableTime === expectedTime ? "On Time" : expectedTime}
          </Text>
        </>
      ) : (
        getDepartureTime(busTime.expectedDepartureTime)
      )}
    </Flex>
  );
};

export default BusArrivalTime;
